<template>
  <section id="SMS" class="section-item">
    <h1>SMS</h1>

    <section id="api-SMS-GetSmsMessagesID">
      <h2>SMS - {{ $t("title.single_sms_query") }}</h2>
      <p>{{ $t("sms.sms_and_reports_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/messages/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">cURL</button>
        <pre>
        <code class="language-bash">
curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/sms/messages/740b441e-4893-4d47-a266-818803cd8d93' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
        </code>
      </pre>

        <h3>{{ $t("general.header") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>String</td>
              <td>
                {{ $t("general.content-type") }}
                <span class="app-json">application/json</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>id</td>
              <td>Number</td>
              <td>
                {{ $t("table.message_id_to_be_consulted") }}
              </td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.request_status") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.text_message_sender") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.text_message_recipient") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>String</td>
              <td>{{ $t("table.sent_message_content") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("table.sending_account_id") }}</td>
            </tr>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>segments</td>
              <td>Number</td>
              <td>{{ $t("table.sms_parts") }}</td>
            </tr>
            <tr>
              <td>price</td>
              <td>Number</td>
              <td>{{ $t("table.individual_message_cost") }}</td>
            </tr>
            <tr>
              <td>carrier</td>
              <td>String</td>
              <td>{{ $t("table.recipient_operator") }}</td>
            </tr>
            <tr>
              <td>ext_id</td>
              <td>String</td>
              <td>{{ $t("table.client_defined_id") }}</td>
            </tr>
            <tr>
              <td>id</td>
              <td>String</td>
              <td>{{ $t("table.specific_sending_id") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>String</td>
              <td>{{ $t("table.sending_date_time") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>String</td>
              <td>{{ $t("table.message_content") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">{{ $t("general.success") }}</button>

        <pre>
        <code class="language-json">HTTP/1.1 200 OK
{
  "id": "740b441e-4893-4d47-a266-818803cd8d93",
  "body": "teste",
  "segments": 1,
  "direction": "outbound",
  "from": "62733",
  "to": "5513997423162",
  "updated_at": "2020-07-28 16:51:03",
  "price": "0.1",
  "carrier": "VIVO",
  "error_message": null,
  "account_id": "5cefcd69-49b8-4d8c-accc-eb81e46e0958",
  "status": "accepted",
  "sent_at": null,
  "created_at": "2020-07-28 16:51:03",
  "error_code": null,
  "gw_id": null,
  "ext_id": null
}</code>
      </pre>

        <button class="btn02">Error-Response</button>
        <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
      </div>
    </section>

    <section id="api-SMS-GetSmsMessagesDirectionDirectionSent_atSent_at">
      <h2>SMS - {{ $t("title.sms_query") }}</h2>
      <p>{{ $t("sms.sms_and_reports_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/messages?direction=:direction&sent_at=:sent_at</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">cURL</button>
        <pre>
        <code class="language-bash">
curl --location --request GET 'https://{{ whitelabel?.api_domain }}/v1/sms/messages' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
        </code>
      </pre>

        <h3>{{ $t("general.header") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Content-Type</td>
              <td>String</td>
              <td>
                {{ $t("general.content-type") }}
                <span class="app-json">application/json</span>
              </td>
            </tr>
          </tbody>
        </table>

        <h3>{{ $t("general.parameter") }}</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>sent_at</td>
              <td>Array</td>
              <td>{{ $t("table.sending_dates") }}</td>
            </tr>
          </tbody>
        </table>

        <h3>Success 200</h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t("general.field") }}</th>
              <th>{{ $t("general.type") }}</th>
              <th>{{ $t("general.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>status</td>
              <td>String</td>
              <td>{{ $t("table.request_status") }}</td>
            </tr>
            <tr>
              <td>from</td>
              <td>String</td>
              <td>{{ $t("table.text_message_sender") }}</td>
            </tr>
            <tr>
              <td>to</td>
              <td>String</td>
              <td>{{ $t("table.text_message_recipient") }}</td>
            </tr>
            <tr>
              <td>body</td>
              <td>String</td>
              <td>{{ $t("table.sent_message_content") }}</td>
            </tr>
            <tr>
              <td>account_id</td>
              <td>String</td>
              <td>{{ $t("table.sending_account_id") }}</td>
            </tr>
            <tr>
              <td>direction</td>
              <td>String</td>
              <td>{{ $t("table.message_direction") }}</td>
            </tr>
            <tr>
              <td>segments</td>
              <td>Number</td>
              <td>{{ $t("table.sms_parts") }}</td>
            </tr>
            <tr>
              <td>price</td>
              <td>Number</td>
              <td>{{ $t("table.individual_message_cost") }}</td>
            </tr>
            <tr>
              <td>carrier</td>
              <td>String</td>
              <td>{{ $t("table.recipient_operator") }}</td>
            </tr>
            <tr>
              <td>ext_id</td>
              <td>String</td>
              <td>{{ $t("table.client_defined_id") }}</td>
            </tr>
            <tr>
              <td>id</td>
              <td>String</td>
              <td>{{ $t("table.specific_sending_id") }}</td>
            </tr>
            <tr>
              <td>created_at</td>
              <td>String</td>
              <td>{{ $t("table.sending_date_time") }}</td>
            </tr>
            <tr>
              <td>updated_at</td>
              <td>String</td>
              <td>{{ $t("table.message_content") }}</td>
            </tr>
          </tbody>
        </table>

        <button class="btn02">{{ $t("general.success") }}</button>

        <pre>
        <code class="language-json">HTTP/1.1 200 OK
{
  "id": "740b441e-4893-4d47-a266-818803cd8d93",
  "body": "teste",
  "segments": 1,
  "direction": "outbound",
  "from": "62733",
  "to": "5513997423162",
  "updated_at": "2020-07-28 16:51:03",
  "price": "0.1",
  "carrier": "VIVO",
  "error_message": null,
  "account_id": "5cefcd69-49b8-4d8c-accc-eb81e46e0958",
  "status": "accepted",
  "sent_at": null,
  "created_at": "2020-07-28 16:51:03",
  "error_code": null,
  "gw_id": null,
  "ext_id": null
}</code>
      </pre>

        <button class="btn02">Error-Response</button>
        <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
      </div>
    </section>

    <section id="api-SMS-PostSmsInsights">
      <h2>SMS - {{ $t("title.consult_report") }}</h2>
      <p>{{ $t("sms.report_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/insights</code></pre>
      </div>

      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>
      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{   
   "begin_date":"2020-07-02 00:00:00",
   "end_date":"2020-07-03 00:00:00",
   "time_window":"daily",
   "direction":"outbound",
}</code>
      </pre>

      <pre v-if="selectedTab === 'curl'">
        <code class="language-bash">
curl -XPOST -H "Content-type: application/json" -d '{"begin_date":"2020-07-02 00:00:00","end_date":"2020-07-03 00:00:00","time_window":"daily","direction":"outbound"}' 'https://{{ whitelabel?.api_domain }}/v1/sms/insights'
-u '[SEU ID]:[SEU TOKEN]'
        </code>
      </pre>
      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.content-type") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>begin_date</td>
            <td>String</td>
            <td>{{ $t("table.start_date") }}</td>
          </tr>
          <tr>
            <td>end_date</td>
            <td>String</td>
            <td>{{ $t("table.end_date") }}</td>
          </tr>
          <tr>
            <td>time_window</td>
            <td>String</td>
            <td>{{ $t("table.time_window") }}</td>
          </tr>
          <tr>
            <td>direction</td>
            <td>String</td>
            <td>{{ $t("table.message_direction_response") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>begin_date</td>
            <td>String</td>
            <td>{{ $t("table.start_date") }}</td>
          </tr>
          <tr>
            <td>end_date</td>
            <td>String</td>
            <td>{{ $t("table.end_date") }}</td>
          </tr>
          <tr>
            <td>time_window</td>
            <td>String</td>
            <td>{{ $t("table.time_window") }}</td>
          </tr>
          <tr>
            <td>direction</td>
            <td>String</td>
            <td>{{ $t("table.message_direction_response") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
        <code class="language-json">HTTP/1.1 200 OK
[
   {
     "date_time":"2020-07-02 00:00:00",
     "values":[0]
   },
   {
     "date_time":"2020-07-03 00:00:00",
     "values":[0]
   }
]</code>
      </pre>

      <button class="btn02">Error-Response</button>
      <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
    </section>

    <section id="api-SMS-PostSmsTemplates">
      <h2>SMS - {{ $t("title.create_template") }}</h2>
      <p>{{ $t("sms.template_creation_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/templates</code></pre>
      </div>

      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{
  "name": "Template de SMS",
  "body": "texto",
  "normalize": 1
}</code>
      </pre>

      <pre v-if="selectedTab === 'curl'">
        <code class="language-bash">
curl -XPOST -H "Content-type: application/json" -d '{"name":"Template de SMS","body":"texto","normalize":1}' 'https://{{ whitelabel?.api_domain }}/v1/sms/templates' -u '[SEU ID]:[SEU TOKEN]'
        </code>
      </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.content-type") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.template_content") }}</td>
          </tr>
          <tr>
            <td>normalize</td>
            <td>Boolean</td>
            <td>
              {{ $t("table.special_characters_param") }}
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}.</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.template_content") }}.</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_template_creator") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.template_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.creation_date_time") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.update_date_time") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
        <code class="language-json">HTTP/1.1 200 OK
  {
    "name": "Template de SMS",
    "body": "texto",
    "account_id": "f98c14fd-8239-4c4f-ae28-143f26820f52",
    "id": "3164512a-6f4a-46ff-9cdd-e14607001ad8",
    "created_at": "2020-08-04T13:29:58.000000Z",
    "updated_at": "2020-08-04T13:29:58.000000Z"
  }</code>
      </pre>

      <button class="btn02">Error-Response</button>
      <pre>
        <code class="language-json">{
  "error": "Error message"
}</code>
      </pre>
    </section>

    <section id="api-SMS-PostSmsMessages">
      <h2>SMS - {{ $t("title.send_sms") }}</h2>
      <p>{{ $t("sms.sms_sending_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/messages</code></pre>
      </div>

      <div class="code-toggle">
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
      </div>

      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{
  "messages": [
    {
      "to": "5513981327195",
      "body": "teste"
    }
  ],
  "default": {
    "body": "Default message",
    "normalize": true
  }
}</code>
      </pre>

      <pre v-if="selectedTab === 'curl'">
        <code class="language-bash">curl --location --request POST 'https://{{ whitelabel?.api_domain }}/v1/sms/messages' \
-u '[SEU ID]:[SEU TOKEN]'
--header 'Content-Type: application/json' \
--data-raw '{
"messages":[
{
  "to":"5513981327195",
  "body":"teste",
  "ext_id":"ID849349"
  "status_callback":"http://callback.com",
  "message_callback":"http://response_callback.com"
}
],
"default":{
"body":"Default message",
"normalize":true
}
}'</code>
      </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.content-type") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>messages</td>
            <td>Array</td>
            <td>{{ $t("table.messages_to_send") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>
              {{ $t("table.phone_number") }}
            </td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.message_text") }}</td>
          </tr>
          <tr>
            <td>ext_id</td>
            <td>String</td>
            <td>{{ $t("table.external_id") }}</td>
          </tr>
          <tr>
            <td>default</td>
            <td>Object</td>
            <td>{{ $t("table.default_values") }}</td>
          </tr>
          <tr>
            <td>status_callback</td>
            <td>String</td>
            <td>{{ $t("table.status_callback_url") }}</td>
          </tr>
          <tr>
            <td>message_callback</td>
            <td>String</td>
            <td>{{ $t("table.response_callback_url") }}</td>
          </tr>
          <tr>
            <td>normalize</td>
            <td>Boolean</td>
            <td>
              {{ $t("table.unicode_substitution") }}
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>status</td>
            <td>String</td>
            <td>{{ $t("table.request_status") }}</td>
          </tr>
          <tr>
            <td>from</td>
            <td>String</td>
            <td>{{ $t("table.text_message_sender") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>{{ $t("table.text_message_recipient") }}</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.sent_message_content") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.sending_account_id") }}</td>
          </tr>
          <tr>
            <td>direction</td>
            <td>String</td>
            <td>{{ $t("table.message_direction") }}</td>
          </tr>
          <tr>
            <td>segments</td>
            <td>Number</td>
            <td>{{ $t("table.sms_parts") }}</td>
          </tr>
          <tr>
            <td>price</td>
            <td>Number</td>
            <td>{{ $t("table.individual_message_cost") }}</td>
          </tr>
          <tr>
            <td>carrier</td>
            <td>String</td>
            <td>{{ $t("table.recipient_operator") }}</td>
          </tr>
          <tr>
            <td>ext_id</td>
            <td>String</td>
            <td>{{ $t("table.client_defined_id") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.specific_sending_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.sending_date_time") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.message_content") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
        <code class="language-json">HTTP/1.1 200 OK
[
 {
  "status": "accepted",
  "from": "62733",
  "to": "5513981327195",
  "body": "teste",
  "account_id": "5cefcd69-49b8-4d8c-accc-eb81e46e0958",
  "direction": "outbound",
  "segments": 1,
  "price": 0.1,
  "carrier": "TIM",
  "ext_id": "ID849349",
  "id": "13853cee-ba67-4cb5-8e69-3bfc063fee6b",
  "updated_at": "2020-07-29 11:13:11",
  "created_at": "2020-07-29 11:13:11"
 }
]</code>
      </pre>

      <button class="btn02">{{ $t("general.returned_statuses") }}</button>
      <pre>
        <code class="language-json">{{$t('general.sent')}}
{{$t('general.delivered')}}
{{$t('general.undelivered')}}
{{$t('general.failed')}}</code>
      </pre>
    </section>

    <section id="api-SMS-DeleteSmsTemplates">
      <h2>SMS - {{ $t("title.delete_template") }}</h2>
      <p>{{ $t("sms.group_deletion_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/messages</code></pre>
      </div>

      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{   
  "ids": ["9864512a-6f4a-46ff-6cdd-e14619001ad7"]
}</code>
      </pre>

      <pre v-if="selectedTab === 'curl'">
        <code class="language-bash">curl -XDELETE -H "Content-type: application/json" -d '{"ids":"3164512a-6f4a-46ff-9cdd-e14619001ad8"}' 'https://{{ whitelabel?.api_domain }}/v1/sms/templates'
-u '[SEU ID]:[SEU TOKEN]'</code>
      </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.content-type") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ids</td>
            <td>Array</td>
            <td>{{ $t("table.template_ids_to_delete") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
        <code class="language-json">HTTP/1.1 200 OK
{
  "message":"template excluido"
}</code>
      </pre>

      <button class="btn02">Error-Response</button>
      <pre>
        <code class="language-json">{
    "error": "Error message"
}</code>
      </pre>
    </section>

    <section id="api-SMS-GetSmsTemplates">
      <h2>SMS - {{ $t("title.list_templates") }}</h2>
      <p>{{ $t("general.list_templates_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/sms/templates</code></pre>
      </div>

      <pre>
        <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/sms/templates'
-u '[SEU ID]:[SEU TOKEN]'</code>
      </pre>

      <h3>Header</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.content-type") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.template_name") }}.</td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{ $t("table.template_content") }}.</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_template_creator") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.template_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.creation_date_time") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.update_date_time") }}</td>
          </tr>
          <tr>
            <td>contacts_count</td>
            <td>Number</td>
            <td>{{ $t("table.contact_count") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
        <code class="language-json">HTTP/1.1 200 OK
{
   "name":"Template de SMS",
   "body":"texto",
   "account_id":"fg8c14fd-8239-4c4f-a2e8-143f26820f52",
   "id":"3164512a-6f4a-46ff-9cdd-e14607001ad8",
   "updated_at":"2020-08-04T13:29:58.000000Z",
   "created_at":"2020-08-04T13:29:58.000000Z"
}</code>
      </pre>

      <button class="btn02">Error-Response</button>
      <pre>
        <code class="language-json">{
    "error": "Error message"
}</code>
      </pre>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "SmsComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
